import { hipaa, privacy, termsAndConditions } from 'src/app/router/paths';
import type { ThemeSpaceType } from 'src/styles/theme';

import { Container, CopyrightText, FooterLink } from './styles';

interface CopyrightFooterProps {
  className?: string;
  isAlignedRight?: boolean;
  marginBottom?: ThemeSpaceType;
  marginRight?: string;
  textColor: 'white' | 'gray';
}

const CopyrightFooter = ({
  className,
  isAlignedRight,
  marginBottom,
  marginRight = '0rem',
  textColor = 'white',
}: CopyrightFooterProps) => {
  return (
    <Container
      className={className}
      isAlignedRight={isAlignedRight}
      marginBottom={marginBottom}
      marginRight={marginRight}
    >
      <CopyrightText textColor={textColor}>© {new Date().getFullYear()} Capsule Corporation&nbsp;</CopyrightText>
      <FooterLink to={termsAndConditions.toPath()}>Terms of Service</FooterLink>
      <FooterLink to={privacy.toPath()}>Privacy Policy</FooterLink>
      <FooterLink to={hipaa.toPath()}>HIPAA Policy</FooterLink>
    </Container>
  );
};

export default CopyrightFooter;
